export default (num) => {
  if (num >= 1000000) {
    return ((num / 1000000).toFixed(2) + 'M').replace(/\./g, ','); // convert to M for number from > 1 million
  } else if (num >= 1000) {
    return Math.round(num / 1000) + 'k'; // convert to K for number from > 1000 < 1 million
  } else {
    return num; // if value < 1000, nothing to do
  }
};
